'use client'

import { PaymentMethod } from '@entities/payment-methods'
import { memo } from 'react'

import { Box, ChipV1, HStack, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  paymentMethods: (PaymentMethod & {
    selected: boolean
    handleSelectPaymentMethod: () => void
    disabled?: boolean
  })[]
}

const PaymentMethodSelector = memo(({ paymentMethods }: Props) => {
  return (
    <HStack className="gap-2">
      {paymentMethods.map((paymentMethod) => {
        if (paymentMethod.disabled) {
          return (
            <VStack
              key={paymentMethod.provider}
              className="flex-1 items-center py-4 h-auto bg-gray-200 gap-2 rounded-lg cursor-not-allowed"
            >
              <Box className="flex items-center justify-center h-6">{paymentMethod.icon}</Box>
              <Typography size="h5" className="text-gray-400">
                {paymentMethod.name}
              </Typography>
            </VStack>
          )
        }

        return (
          <VStack
            as={ChipV1}
            key={paymentMethod.provider}
            className="flex-1 items-center py-4 h-auto"
            selected={paymentMethod.selected}
            onClick={paymentMethod.handleSelectPaymentMethod}
          >
            <VStack as="span" className="gap-2">
              <Box as="span" className="flex items-center justify-center h-6">
                {paymentMethod.icon}
              </Box>
              <Typography asChild={true} size="body1" className="font-medium">
                <span>{paymentMethod.name}</span>
              </Typography>
            </VStack>
          </VStack>
        )
      })}
    </HStack>
  )
})

export default PaymentMethodSelector
